import React from 'react';

const Skeleton = ({ variant = 'text', width, height, className = '', count = 1 }) => {
  const baseClass = 'skeleton';

  const getStyle = (isLast) => {
    const style = {};
    if (width) style.width = typeof width === 'number' ? `${width}px` : width;
    if (height) style.height = typeof height === 'number' ? `${height}px` : height;

    if (variant === 'text' && !height) style.height = '1em';
    if (variant === 'text' && !width) style.width = isLast && count > 1 ? '60%' : '100%';
    if (variant === 'circle') {
      const size = width || height || 40;
      const px = typeof size === 'number' ? `${size}px` : size;
      style.width = px;
      style.height = px;
      style.borderRadius = '50%';
    }
    return style;
  };

  if (variant === 'text' && count > 1) {
    return (
      <div className={`flex flex-col gap-2 ${className}`}>
        {Array.from({ length: count }).map((_, i) => (
          <div
            key={i}
            className={baseClass}
            style={getStyle(i === count - 1)}
          />
        ))}
      </div>
    );
  }

  return <div className={`${baseClass} ${className}`} style={getStyle(false)} />;
};

export default Skeleton;
